import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyNewsDetailResolver } from '../core/resolver/company-news-detail-resolver';
import { CompanyNewsHomeResolver } from '../core/resolver/company-news-home-resolver';

import { CompanyNewsComponent } from './company-news.component';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  { path: '', component: CompanyNewsComponent ,
  children: [
    { path: '',resolve: { companyNewsHomeResolver: CompanyNewsHomeResolver  }, component:HomeComponent} ,
    { path: ':id',data: { revalidate: 30 },resolve: { companyNewsDetailResolver: CompanyNewsDetailResolver  }, component: DetailComponent },
  ] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanyNewsRoutingModule { }
